<nav class="navbar navbar-expand-lg align-items-lg-center container-p-x">
  <div class="navbar-collapse collapse">
    <div class="navbar-nav align-items-lg-center">
      <h4 class="fw-bold py-3 mb-4">FETRAPI</h4>
    </div>
  </div>
  <div _ngcontent-bgc-c3="" class="navbar-text me-lg-4">
    <h4 _ngcontent-bgc-c3="" class="fw-bold d-none d-md-block pt-3"></h4>
  </div>
  <div _ngcontent-bgc-c3="" class="navbar-text">
    <button
      _ngcontent-bgc-c10=""
      class="btn btn-outline-dark"
      [ngClass]="{'selected': getLoginDisplay() === false}"
      type="button"
      (click)="loginPopup()"
    >
      Login
    </button>
  </div>
</nav>
